var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{attrs:{"id":"navSocial"}},_vm._l((_vm.nav),function(item){return _c('a',{attrs:{"href":item.url,"title":item.title,"target":"_blank"}},[_c(item.icon,{tag:"component"})],1)}))}
var staticRenderFns = []

export { render, staticRenderFns }